export const query_PPE_byAzienda = `
    query getPPEByAzienda($aziendaId : Int!){
        fascicolo(where: {AziendaId: {_eq: $aziendaId}}) {
            Id
            anagrafica_fascicolos(distinct_on: AnagraficaId) {
                TipoAnagId
                anagrafica {
                    Id
                    IsPep
                    IsNotPepMoreThanYear        
                }
            }
        }
    }
`;
export const query_RischioSpecificoCliente_byAzienda = `
    query GetUltimiRischiPerPrestazionePerProfessionista($aziendaId: Int!) {
        rischio(
            where: {
                prestazione: { 
                    fascicolo: { AziendaId: { _eq: $aziendaId } },
                    _or: [{ EndDate: { _is_null: true } }, { EndDate: { _gt: NOW } }]
                }
            },
            order_by: { Date: desc }
        ) {
            Id
            PrestazioneId
            ProvidedBy
            Date
            SpASubTotale
            prestazione {
                Id
                Descrizione
                fascicolo {
                    Id
                    AziendaId
                }
            }
            user {
                UserId
                Username
                Name
                Surname
            }
        }
    }
`;
export const query_ZonaGeografica_byAzienda = `
    query GetProvinceRischioByAzienda($aziendaId: Int!) {
        fascicolo(where: { AziendaId: { _eq: $aziendaId } }) {
            Id
            anagrafica_fascicolos(distinct_on: AnagraficaId) {    
                AnagraficaId    
                anagrafica {                
                    AddrProvinciaId
                    base_provincium {
                        Sigla
                        Rischio
                    }
                }
            }
        }
    }
`;
export const query_valutazioni_byAzienda = `
    query GetLatestRischioByAzienda($aziendaId: Int!) {
        fascicolo(where: { AziendaId: { _eq: $aziendaId } }) {
            Id
            prestaziones(where: { _or: [{ EndDate: { _is_null: true } }, { EndDate: { _gt: NOW } }] }) {
                Id
                rischios(order_by: { Date: desc }, limit: 1) {
                    Date
                }
            }
        }
    }   
`;
export const query_zonaGeograficaPrestazione_ByAzienda = `
    query GetzonaGeograficaPrestazioneByAzienda ($aziendaId : Int!){
        fascicolo(where: { AziendaId: { _eq: $aziendaId } }) {
            Id
            prestaziones(where: { _or: [{ EndDate: { _is_null: true } }, { EndDate: { _gt: NOW } }] }) {
                ProvinciaId
                base_provincium {
                    Nome
                    Sigla
                    Rischio
                }        
            }
        }
    }
`;
export const query_AValues_byAzienda = `
query GetUltimiRischiPerPrestazionePerProfessionista($aziendaId: Int!) {
        rischio(
            where: {
                prestazione: { 
                    fascicolo: { AziendaId: { _eq: $aziendaId } },
                    _or: [{ EndDate: { _is_null: true } }, { EndDate: { _gt: NOW } }]
                }
            },
            order_by: { Date: desc }
        ) {
            Id
            PrestazioneId
            ProvidedBy
            SpA1Livello
            SpA2Livello
            SpA3Livello
            SpA4Livello
            prestazione {
                Id                
                fascicolo {
                    Id
                    AziendaId
                }
            }
            user {
                UserId
                Username
                Name
                Surname
            }
        }
    }    
`;
export const query_BValues_byAzienda = `
query GetUltimiRischiPerPrestazionePerProfessionista($aziendaId: Int!) {
        rischio(
            where: {
                HasTabellaB: { _eq: true },
                prestazione: { 
                    fascicolo: { AziendaId: { _eq: $aziendaId } },
                    _or: [{ EndDate: { _is_null: true } }, { EndDate: { _gt: NOW } }]
                }
            },
            order_by: { Date: desc }
        ) {
            Id
            PrestazioneId
            ProvidedBy
            SpB1Livello
            SpB2Livello
            SpB3Livello
            SpB4Livello
            SpB5Livello
            SpB6Livello
            prestazione {
                Id                
                fascicolo {
                    Id
                    AziendaId
                }
            }
            user {
                UserId
                Username
                Name
                Surname
            }
        }
    }      
`;
export const query_CValues_byAzienda = `
    query GetRischiByAzienda($aziendaId: Int!) 
    {
        fascicolo(where: { AziendaId: { _eq: $aziendaId } }) {
            Id
            prestaziones(where: { _or: [{ EndDate: { _is_null: true } }, { EndDate: { _gt: NOW } }] }) {
                rischios (where : { HasTabellaB: { _eq: true }}) {
                    SpC1_1_Livello
                    SpC1_2_Livello
                    SpC1_3_Livello                    
                }
            }
        }
    }
`;
export const query_Prest_RischioInerente_ByAzienda = `
    query GetRischioInerenteByAzienda ($aziendaId : Int!){
        fascicolo(where: { AziendaId: { _eq: $aziendaId } }) {
            Id
            prestaziones(where: { _or: [{ EndDate: { _is_null: true } }, { EndDate: { _gt: NOW } }] }) {
                Id
                base_tipo_prestazione{                                       
                    Rischio
                }        
            }
        }
    }
`;
export const query_RischioSpecifico_byAzienda = `
    query GetUltimiRischiPerPrestazionePerProfessionista($aziendaId: Int!) {
        rischio(
            where: {
                prestazione: { 
                    fascicolo: { AziendaId: { _eq: $aziendaId } },
                    _or: [{ EndDate: { _is_null: true } }, { EndDate: { _gt: NOW } }]
                }
            },
            order_by: { Date: desc }
        ) {
            Id
            PrestazioneId
            ProvidedBy
            Date
            EfSpTotale            
            prestazione {
                Id
                Descrizione
                fascicolo {
                    Id
                    AziendaId
                }
            }
            user {
                UserId
                Username
                Name
                Surname
            }
        }
    }
`;
export const query_RischioSpecPrestazione_ByAzienda = `
    query GetUltimiRischiPerPrestazionePerProfessionista($aziendaId: Int!) {
        rischio(
            where: {
                HasTabellaB: { _eq: true },
                prestazione: { 
                    fascicolo: { AziendaId: { _eq: $aziendaId } },
                    _or: [{ EndDate: { _is_null: true } }, { EndDate: { _gt: NOW } }]
                }
            }            
        ) {     
            SpBSubTotale
            PrestazioneId
            ProvidedBy            
            Date
            prestazione {
                Id                
                base_tipo_prestazione{                                       
                    Rischio
                }
            }           
        }
    }  
`;
export const query_RischioEffettivo_byAzienda = `
    query GetUltimiRischiPerPrestazionePerProfessionista($aziendaId: Int!) {
        rischio(
            where: {
                prestazione: { 
                    fascicolo: { AziendaId: { _eq: $aziendaId } },
                    _or: [{ EndDate: { _is_null: true } }, { EndDate: { _gt: NOW } }]
                }
            },
            order_by: { Date: desc }
        ) {
            Id
            PrestazioneId
            ProvidedBy
            Date
            EfTotale            
            prestazione {
                Id
                Descrizione
                fascicolo {
                    Id
                    AziendaId
                }
            }
            user {
                UserId
                Username
                Name
                Surname
            }
        }
    }
`;
